import PermissionGuard from 'components/Global/PermissionGuard'; 
import CategoryCodeComponent from 'components/Settings/Masters/CategoryCode';

export const CategoryCode = () => {
	return (
		<PermissionGuard permission="Allow_Category_Code">
			<CategoryCodeComponent />
		</PermissionGuard>
	);
};
